import { render, staticRenderFns } from "./JWL_Student.vue?vue&type=template&id=40a98a8a&"
import script from "./JWL_Student.vue?vue&type=script&lang=ts&"
export * from "./JWL_Student.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports